module.exports = {
  websiteStaticURL: "https://home.saudiblood.org",
};
